import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      paddingBottom: theme.spacing(4),
    },

    menuContainer: {
      height: '100%',
      borderRight: `1px solid #E2E2E2`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',

      '& li': {
        margin: theme.spacing(2, 0),
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightBold,
        borderRadius: 25,
        justifyContent: 'center',

        '&.selected': {
          color: theme.palette.primary.contrastText,
          background: theme.palette.primary.light,
        },
      },

      '& li#logout-button': {
        justifyContent: 'flex-start',
      },
    },

    topContainer: {
      marginBottom: theme.spacing(4),
      display: 'flex',
      alignItems: 'center',
    },
    helloContainer: {
      marginLeft: theme.spacing(2),
      '& h2': {
        marginBottom: theme.spacing(0.5),
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,

        [theme.breakpoints.up('sm')]: {
          color: theme.palette.text.primary,
          fontSize: theme.typography.pxToRem(26),
        },
      },
    },
    userAvatar: {
      width: theme.spacing(9),
      height: theme.spacing(9),
      border: `2px solid ${theme.palette.primary.contrastText}`,
      boxShadow: theme.shadows[2],

      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(13),
        height: theme.spacing(13),
      },
    },

    divider: {
      width: '90%',
    },

    form: {
      marginLeft: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(2),
      },

      '& h2': {
        marginBottom: theme.spacing(3),
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
        alignSelf: 'flex-start',

        [theme.breakpoints.up('sm')]: {
          fontSize: theme.typography.pxToRem(26),
        },
      },
    },

    title: {
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,

      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(26),
      },
    },
  })
);

export default useStyles;
